import React from 'react'
import Menubar from './Menubar'
import Topbar from './Topbar'
import LicensePurchase from './LicensePurchase'
import { IoClose } from "react-icons/io5";

export default function Web() {
    return (
        <div className='w-full h-screen flex bg-gray-100 justify-center items-center'>

            
            <Menubar />
            
            <div className='flex flex-col flex-1 h-screen overflow-hidden'>
                <Topbar />
                <div className='h-8 border-b flex items-center bg-white'>
                    <div className='max-w-[200px] px-4 h-full border-r bg-[#D6E8F3] flex items-center gap-3 text-[#14181FCC]'>
                        <span>LicensePurchase</span>
                        <IoClose className='hover:text-red-500 cursor-pointer' />
                    </div>
                </div>

                <div className='flex-1 overflow-y-auto '>
                    <LicensePurchase />
                </div>

            </div>
        </div>
    )
}